const DEALROADSHOW_HEADER_NAMESPACE = 'dealroadshowHeader';

export default DEALROADSHOW_HEADER_NAMESPACE;
